export enum AnswerTrackerType {
    Answer = 'ans'
}
